"use client";
import { usePrice } from "@/hooks";
import classnames from "classnames";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import { useSelector } from "react-redux";

export const PriceHostingContent = ({
  content: {
    price,
    redirect = null,
    suffix = "/",
    info = "",
    btnText,
    show = true,
  },
  submitHandle,
}) => {
  const pathname = usePathname();
  const formatAmount = usePrice();
  const t = useTranslations();
  const { editableOption } = useSelector((state) => state.hosting);

  const scrollDown = () => {
    window.scrollTo({
      top: screen.height - 300,
      behavior: "smooth",
    });
  };
  const isEditabelOpened = pathname.includes("vps-hosting") && !!editableOption;
  const currencySymbol = pathname.includes("vps-hosting") ? false : true;

  const btnClasses = classnames(
    {
      "cursor-not-allowed": isEditabelOpened,
      "cursor-pointer": !isEditabelOpened,
    },
    "sm:h-10 md:h-[50px] text-base cursor-not-allowed px-8 bg-mainLightPurple hover:bg-mainLightPurpleHover active:bg-mainLightPurpleActive rounded-lg text-white !w-max"
  );

  const contentClasses = classnames(
    {
      "opacity-25": isEditabelOpened,
      "opacity-100": !isEditabelOpened,
    },
    "sm:py-3 sm:p-2 md:py-6 flex max-h-[122px] justify-between items-center md:p-[24px]"
  );
  return (
    <div className="sm:w-11/12 sm:mx-auto sm:mt-4 md:mt-0 md:w-full bg-white rounded-[8px] max-w-[856px]">
      <div className={contentClasses}>
        <div className="flex flex-col gap-1">
          {show && <span className="text-slate-500">{t("startingAt")}</span>}
          <div className="flex gap-1">
            <span className="sm:text-2xl md:text-[32px] text-slate-700 font-medium leading-[38px]">
              {formatAmount(price)}
            </span>
            <span className="sm:text-sm md:text-base text-slate-500 self-end">
              {suffix + t("month")}
            </span>
          </div>
          <span className="sm:text-sm md:text-base text-slate-400 leading-[24px]">
            {info}
          </span>
        </div>
        <div>
          <button
            className={btnClasses}
            onClick={() => (redirect ? scrollDown() : submitHandle())}
          >
            {btnText}
          </button>
        </div>
      </div>
    </div>
  );
};
